// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__B-feJ","footer":"styles_footer__2TD5R","passCodeTooltip":"styles_passCodeTooltip__1pMgB"};